module.exports = "<svg viewBox=\"0 0 80 80\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M51 19H37L20 43H35L26.5 64.5L55 34H40L51 19Z\"></path></svg>"